import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';
import swal from 'sweetalert2';


@Component({
  selector: 'app-payment-result-normal',
  templateUrl: './payment-result-normal.component.html',
  styleUrls: ['./payment-result-normal.component.scss']
})
export class PaymentResultNormalComponent implements OnInit {
  queryObj: any;
  payment_id: any;
  payment_status: any;
  id: any;
  transaction_id: any;
  response_data: any;

  constructor(private route: ActivatedRoute, public router: Router, private service: ServiceService) { }

  ngOnInit(): void {

    this.route.queryParamMap
      .subscribe((params) => {
        this.queryObj = { ...params.keys, ...params };
      }

      );
    //console.log("params :" +JSON.stringify(this.queryObj)) 

    var paydata = {
      payment_id: this.queryObj.params.payment_id,
      payment_status: this.queryObj.params.payment_status,
      payment_request_id: this.queryObj.params.payment_request_id
    }

    /*
    var paydata = {
      payment_id: 'MOJO3909105N63517615',
      payment_status: 'Credit',
      payment_request_id: 'e76722317ba84c59b5209bf1c5fbe206'
    }
    */

    this.service.UpdatePaymentStatus(paydata)
      .subscribe((data) => {
        this.response_data = data;
        if (this.response_data.code == "200") {
          swal.fire('Thank you.', this.response_data.message, 'success').then((result) => {
            if (result.value) {
              window.self.close();
            }
            this.router.navigate(["/base/patient/appoinment"]);
          })

        }
        /*
        else {
          swal.fire({
            icon: 'error',
            text: this.response_data.message,
          }).then((result) => {
            if (result.value) {
              window.self.close();
            }
          })
        }
        */

      }
         , (error) => {
           alert('Payment was not successfully. Please try again.');
           window.self.close();

        }
      );


  }

}